export default {"src":"/_next/static/media/nft-api.db3157b9.svg","height":32,"width":32};